import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('simple-notes/payment-plans', { params, ...config }),
  show: (id, params = {}, config = {}) => axios.get(`simple-notes/payment-plans/${id}`, { params, ...config }),
};
